import * as React from 'react';
import * as styles from '../styles/actionFormSection.module.scss';

function ActionFormSection({ children }) {
  return (
    <section className={styles.actionFormSection}>
      <div>{children}</div>
    </section>
  );
}
export default ActionFormSection;
